import {defineRule, recipes, self} from '../Utilities/jss';
import {font} from './fonts';
import {theme as t} from './theme';

export const Field = defineRule('.\\~Field', {
    ...self.element('input', {
        backgroundColor: t.colors.neutral['10'],
        outline: 'none',
        width: '100%',
        borderRadius: t.borderRadius.sm,
        border: `1px solid ${t.colors.neutral['40']}`,
        paddingLeft: t.spacing['3'],
        paddingRight: t.spacing['9'],
        ...font['text-xl-regular'],
        color: t.colors.neutral['90'],
        height: t.spacing['11'],

        ...self.placeholder({
            color: t.colors.neutral['60'],
        }),

        ...self.focus({
            color: t.colors.neutral['100'],
            borderColor: t.colors.primary['30'],
            ...recipes.ring('0px', '3px', t.colors.primary['20']),
        }),

        ...self.disabled({
            borderColor: t.colors.neutral['50'],
            backgroundColor: t.colors.neutral['30'],
            color: t.colors.neutral['60'],
        }),

        ...self.modifier('unsetHeight', {
            height: 'unset',
        }),
    }),

    ...self.element('decor', {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        ...self.modifier('default', {
            right: t.spacing['3'],
            width: t.spacing['4'],
            height: t.spacing['4'],
        }),
        ...self.modifier('big', {
            right: t.spacing['2'],
            width: t.spacing['7'],
            height: t.spacing['7'],
        }),
    }),

    ...self.element('innerBox', {
        position: 'relative',
        display: 'flex',
    }),

    ...self.element('root', {
        ...font['text-m-regular'],
        position: 'relative',
        display: 'grid',
        gap: t.spacing['2'],
        ...self.modifier('invalid', {
            '.\\~Field__input': {
                borderColor: t.colors.danger['30'],
                ...self.focus({
                    ...recipes.ring('0px', '3px', t.colors.danger['20']),
                }),
            },
            '.\\~Field__helper': {
                color: t.colors.danger['30'],
            },
        }),
    }),

    ...self.element('helper', {
        position: 'absolute',
        left: '0',
        top: '100%',
        paddingTop: t.spacing['1'],
        color: t.colors.neutral['60'],
    }),

    ...self.element('label', {
        display: 'flex',
        alignItems: 'center',
        gap: t.spacing['1'],
        color: t.colors.neutral['100'],
    }),

    ...self.element('labelIconBox', {
        display: 'flex',
        width: t.spacing['4'],
        height: t.spacing['4'],
        alignItems: 'center',
        justifyContent: 'center',
        color: t.colors.neutral['60'],
    }),

    ...self.element('labelSubtext', {
        color: t.colors.neutral['60'],
    }),
});
